module.exports = __webpack_public_path__ + "img/02.8177d8dd.png";